import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function LoadingSpinner({ message = 'Chargement...' }) {
    return (
        <Box display="flex" flexDirection="column" alignItems="center"
             justifyContent="center" minHeight="100vh" gap={2}>
            <CircularProgress size={48} sx={{ color: '#1a5276' }} />
            <Typography color="text.secondary">{message}</Typography>
        </Box>
    );
}
